import React from 'react';
import { motion } from 'framer-motion';
import { BookX, Clock, BrainCircuit } from 'lucide-react';
export function FailedSolutionsSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-10">
      <div className="max-w-6xl mx-auto" data-id="element-11">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-12">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-13">
            <h2 className="text-3xl md:text-4xl font-bold text-brown mb-6" data-id="element-14">
              Has intentado hablarlo. <br data-id="element-15" />
              <span className="text-terracotta italic" data-id="element-16">Lo sabemos.</span>
            </h2>
            <p className="text-lg text-brown-light mb-6 leading-relaxed" data-id="element-17">
              Sabemos que los consejos de otros o los libros interminables no
              han funcionado. No porque no quieras, sino porque no hay tiempo
              para teorías largas cuando tienes un bebé.
            </p>
            <p className="text-lg text-brown-light mb-8 leading-relaxed" data-id="element-18">
              Intentar tener "la gran conversación" a las 11 de la noche, cuando
              ambos están agotados, solo lleva a más frustración. Necesitas algo
              diferente.
            </p>

            <div className="space-y-4" data-id="element-19">
              <div className="flex items-start gap-4" data-id="element-20">
                <div className="bg-red-50 p-2 rounded-lg mt-1" data-id="element-21">
                  <BookX className="w-5 h-5 text-terracotta" data-id="element-22" />
                </div>
                <div data-id="element-23">
                  <h4 className="font-bold text-brown" data-id="element-24">Sin tiempo para leer</h4>
                  <p className="text-sm text-brown-light" data-id="element-25">
                    Los libros de 300 páginas se quedan en la mesita de noche
                    acumulando polvo.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4" data-id="element-26">
                <div className="bg-red-50 p-2 rounded-lg mt-1" data-id="element-27">
                  <Clock className="w-5 h-5 text-terracotta" data-id="element-28" />
                </div>
                <div data-id="element-29">
                  <h4 className="font-bold text-brown" data-id="element-30">
                    Conversaciones interrumpidas
                  </h4>
                  <p className="text-sm text-brown-light" data-id="element-31">
                    Cuando por fin empiezan a hablar, el bebé llora o el
                    cansancio gana.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4" data-id="element-32">
                <div className="bg-red-50 p-2 rounded-lg mt-1" data-id="element-33">
                  <BrainCircuit className="w-5 h-5 text-terracotta" data-id="element-34" />
                </div>
                <div data-id="element-35">
                  <h4 className="font-bold text-brown" data-id="element-36">Sobrecarga mental</h4>
                  <p className="text-sm text-brown-light" data-id="element-37">
                    Demasiada información contradictoria que paraliza en lugar
                    de ayudar.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-38">
            <div className="bg-cream rounded-3xl p-8 md:p-12 border border-blush/30 shadow-xl relative overflow-hidden" data-id="element-39">
              <div className="absolute top-0 right-0 w-32 h-32 bg-terracotta/10 rounded-full blur-3xl -mr-10 -mt-10" data-id="element-40"></div>
              <div className="absolute bottom-0 left-0 w-32 h-32 bg-blush/20 rounded-full blur-3xl -ml-10 -mb-10" data-id="element-41"></div>

              <h3 className="text-2xl font-serif font-bold text-brown mb-6 relative z-10" data-id="element-42">
                La realidad de padres agotados
              </h3>
              <blockquote className="text-xl italic text-brown-light mb-6 relative z-10" data-id="element-43">
                "Queríamos ponernos de acuerdo, pero siempre terminábamos
                discutiendo por tonterías. No nos faltaba amor, nos faltaba un
                sistema."
              </blockquote>
              <div className="flex items-center gap-3 relative z-10" data-id="element-44">
                <div className="w-10 h-10 rounded-full bg-terracotta/20 flex items-center justify-center text-terracotta font-bold" data-id="element-45">
                  M
                </div>
                <div data-id="element-46">
                  <p className="font-bold text-brown text-sm" data-id="element-47">María G.</p>
                  <p className="text-xs text-brown-light" data-id="element-48">
                    Madre de un bebé de 6 meses
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}